<template>
  <div class="form_title">
    <span class="form_title_text">{{ title }}:</span>
    <el-tooltip
      v-if="tooltip"
      class="item"
      effect="dark"
      :content="tooltip"
      placement="top-start"
    >
      <i class="el-icon-question" />
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: 'FormTitle',
  props: {
    title: {
      type: String
    },
    tooltip: {
      default: '',
      type: String
    },
    desc: {
      default: '',
      type: String
}
  },
  data () {
    return {}
  },
  watch: {},
  created () {},
  methods: {}
}
</script>

<style scoped lang="scss">
.form_title {
  margin-bottom: 14px;
  &_text {
    margin-right: 5px;
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
}
</style>
